(function() {
    'use strict';
    angular
        .module('askApp')
        .factory('Crew', Crew);

    Crew.$inject = ['$resource'];

    function Crew ($resource) {
        var resourceUrl =  'api/crews/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
